export default "__VITE_ASSET__CPp4nqvE__"